
// test:    http://zzdataapi.ftmore.com
// http://bambooapi.ftmore.com
// test:    wx6cf2eba9d992eb67
// office:   wx0ce69aba0709b60c
const config = {
  debug: false,
  serviceHost: the_host,
  apiVersion: 'v1',
  apiParam: {
    // terminalType: 'wap'
  },
  testuser: 'admin',
  testpwd: 'admin123456',
  lbskey: 'VTLBZ-EKXWO-BNMW5-SRWZE-PNPGE-2BFCM',
	mjApiKey: 'e4a48a972598456c9fe1bd41a14a0797'
}

export default config



// WEBPACK FOOTER //
// ./src/config.js